import { render, staticRenderFns } from "./DemoOffering.vue?vue&type=template&id=3ffe7de4&scoped=true"
import script from "./DemoOffering.vue?vue&type=script&lang=ts"
export * from "./DemoOffering.vue?vue&type=script&lang=ts"
import style0 from "./DemoOffering.vue?vue&type=style&index=0&id=3ffe7de4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffe7de4",
  null
  
)

export default component.exports